import { useEntityTenantStore } from "@/store/entityTenantStore";
import { useRecordTenantStore } from "@/store/recordTenantStore";

/**
 * SERV-3232: the entity a request goes out in when the call names none, in axiosInstance's order
 * (the open record, then the label-menu pick). A query whose answer depends on it carries it in
 * its key and sends it per call, so the two cannot disagree when the scope changes mid-flight.
 */
export function getRequestScope(): string {
  return (
    useRecordTenantStore.getState().recordTenant ?? useEntityTenantStore.getState().entityTenant
  );
}

/**
 * The scope a route is about to run in: the record its `?tenant=` opens, else the pick. A guard
 * or loader runs before the route's `onEnter` moves the record store, which at that point still
 * holds the route being left.
 */
export function getDestinationScope(search: Record<string, unknown> | undefined): string {
  const tenant = search?.tenant;
  return typeof tenant === "string" && tenant !== ""
    ? tenant
    : useEntityTenantStore.getState().entityTenant;
}

export function useRequestScope(): string {
  const recordTenant = useRecordTenantStore((state) => state.recordTenant);
  const entityTenant = useEntityTenantStore((state) => state.entityTenant);
  return recordTenant ?? entityTenant;
}
